import { Controller } from "@hotwired/stimulus"

const TYPES = ["protanopia", "deuteranopia", "tritanopia", "achromatopsia"]
const STORAGE_KEY = "appDaltonize"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.onChange = this.onChange.bind(this)
    const saved = localStorage.getItem(STORAGE_KEY) || ""
    if (this.hasSelectTarget) {
      this.selectTarget.value = saved
      this.selectTarget.addEventListener("change", this.onChange)
    }
    this.applyFilter(saved)
  }

  disconnect() {
    if (this.hasSelectTarget) this.selectTarget.removeEventListener("change", this.onChange)
  }

  onChange(event) {
    const value = event.target.value
    localStorage.setItem(STORAGE_KEY, value)
    this.applyFilter(value)
  }

  applyFilter(value) {
    const root = document.documentElement
    TYPES.forEach((t) => root.classList.remove(`dalt-${t}`))
    if (TYPES.includes(value)) root.classList.add(`dalt-${value}`)
  }
}
